// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  name: {
    amigo: 'Amigo',
    assistant: 'Assistent',
  },
  close: {
    amigo: 'Amigo sluiten',
    assistant: 'De assistent sluiten',
  },
  brand: 'Merk',
  // The header (D4): Chats opens the restaurant's chats in the panel, New chat starts an empty one.
  chats: 'Chats',
  new_chat: 'Nieuwe chat',
  back: 'Terug naar de chat',
  // Other chats with answers the person hasn't read (QA45): the line under the header leads to Chats.
  news_elsewhere_one: 'Nieuwe antwoorden in een andere chat',
  news_elsewhere_other: 'Nieuwe antwoorden in {{count}} andere chats',
};
